<template>
    <div>
        <b-alert show variant="warning">
            <div>
                <b-input v-model="new_comment.comment" :disabled="loading" placeholder="new comments here.." style="font-size: 13px;">

                </b-input>
            </div>

            <div style="margin-top: 3px; text-align: center;">
                <button :disabled="loading" @click="save">SUBMIT</button>
            </div>
        </b-alert>


        <div v-if="items_being_loaded">
            <loading 
            :active="true" 
            :can-cancel="false" 
            :is-full-page="false">
            </loading>
        </div>
        <div v-else>
            <b-alert show v-for="item,idx in items" v-bind:key="idx">
                <sub><span style="padding: 2px; background: yellow;">{{item.username}}</span> <span style="padding: 3px; background: white;">({{item.ts}})</span>:</sub>
                <div>
                    {{ item.comment }}
                </div>
            </b-alert>
        </div>

    </div>
</template>

<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import Requestor from '@/utilities/Requestor'
    import moment from 'moment'
    export default {
        name: "ItemComments",
        components: {Requestor,Loading},
        props: ["viewdata"],
        data: function(){
            return {
                new_comment: {
                    comment: null,
                    username: null,
                    itemid: null,
                    invoice_id: null
                },
                items_being_loaded: false,
                loading: false,
                items: [],
                metadata: {}
            }
        },
        methods: {
            save: function(e){
                if (e){
                    e.preventDefault();
                }

                let that = this;
                let path = "/api/sales/add_item_comment/"
                let data = this.new_comment;

                if (!data.comment || (data.comment || '').length < 2){
                    this.$vex.dialog.alert({
                        message: "Comment text cannot be empty."
                    });
                    return
                }
                data.username = this.metadata.username;
                data.invoice_id = this.metadata.invoice_id;
                data.itemid = this.metadata.itemid;

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Successfully new comment.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        that.new_comment.comment = null;
                        that.fetch_init();
                    }
                    that.loading = false
                    
                }
                let f =  function(error){
                    that.$bvToast.toast(
                        "Error adding new comment.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.loading = false;
                }
                this.loading = true;
                Requestor.postAsync(path, data, s, f);
            },
            fetch_init: function(){
                let that = this;
                let prereqs = [
                    {
                        path: "/api/sales/get_item_comments/",
                        data: {invoice_id: this.metadata.invoice_id,
                            itemid: this.metadata.itemid},
                        s: function(response){
                            if (response.data.error){
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                            else {
                                that.items = response.data.result;
                            }
                            that.items_being_loaded = false
                            
                        },
                        f: function(error){
                            that.$bvToast.toast(
                                "Error loading vendor order.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                            that.items_being_loaded = false;
                        },
                        type: "",
                        executable: Requestor.getAsync
                    }
                ];

                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);
                    }
                    else {
                        console.log("e")
                        prereqs[i]["executable"](path, data, s, f);
                    }
                }
            }
        },
        mounted: function(){
            this.metadata = JSON.parse(JSON.stringify(this.viewdata));
            this.fetch_init()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/importables/ItemComments.vue